import { Reducer } from "redux";
import { ADD_NP_SHIFT, SET_NP_SHIFTS } from "../actions/npShiftsActions";

interface IValue {
    [key: string]: INPShiftElem;
}

export interface INPShiftElem extends Record<string, number | string | undefined> {
    key?: string;
    value: number;
    bznShift: number;
}

export interface INPShift {
    hour: number;
    values: IValue;
}

export const npShiftsInit: INPShift = {
    hour: -1,
    values: {
        al: { value: 0, bznShift: 1 },
        at: { value: 0, bznShift: 0 },
        ba: { value: 0, bznShift: 1 },
        be: { value: 0, bznShift: 0 },
        bg: { value: 0, bznShift: 1 },
        ch: { value: 0, bznShift: 1 },
        cz: { value: 0, bznShift: 0 },
        de: { value: 0, bznShift: 0 },
        dk1: { value: 0, bznShift: 1 },
        es: { value: 0, bznShift: 1 },
        fr: { value: 0, bznShift: 0 },
        gr: { value: 0, bznShift: 1 },
        hr: { value: 0, bznShift: 0 },
        hu: { value: 0, bznShift: 0 },
        it: { value: 0, bznShift: 1 },
        md: { value: 0, bznShift: 1 },
        me: { value: 0, bznShift: 1 },
        mk: { value: 0, bznShift: 1 },
        nl: { value: 0, bznShift: 0 },
        pl: { value: 0, bznShift: 0 },
        pt: { value: 0, bznShift: 1 },
        ro: { value: 0, bznShift: 0 },
        rs: { value: 0, bznShift: 1 },
        si: { value: 0, bznShift: 0 },
        sk: { value: 0, bznShift: 0 },
        tr: { value: 0, bznShift: 1 },
        ua: { value: 0, bznShift: 1 },
        be_al: { value: 0, bznShift: 1 },
        de_al: { value: 0, bznShift: 1 },
    },
};

export interface NPShiftsState {
    npShifts: INPShift[];
}

const initialState: NPShiftsState = {
    npShifts: [],
};

export const npShiftsReducer: Reducer<NPShiftsState> = (
    state: NPShiftsState = initialState,
    action: any
): NPShiftsState => {
    switch (action.type) {
        case SET_NP_SHIFTS:
            return { ...state, npShifts: action.nps };
        case ADD_NP_SHIFT:
            if (state.npShifts.some(x => x.hour === action.np.hour)) {
                const newNpShifts = state.npShifts.filter(x => x.hour !== action.np.hour);
                return { ...state, npShifts: newNpShifts.concat(action.np) };
            } else return { ...state, npShifts: state.npShifts.concat(action.np) };
        default:
            return state;
    }
};
